module.exports = __webpack_public_path__ + "static/img/9.7640f1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/culturalCourses/9.png
// module id = fxsl
// module chunks = 0